import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  display: flex;

  .clientsSelectedDrawer > .ant-drawer-content-wrapper {
    height: 7rem !important;
  }
  .clientsSelectedDrawer > .ant-drawer-mask {
    display: none;
  }

  @media only screen and (max-device-width: 812px) {
    padding: 0;
    
    // Correção para a paginação em mobile
    .ant-col-clients-table {
      .ant-table-wrapper {
        .ant-spin-nested-loading {
          .ant-spin-container {
            .ant-table-pagination {
              position: relative !important;
              bottom: auto !important;
              margin: 16px 0 0 0 !important;
              padding: 16px !important;
              border-top: 1px solid var(--ghost);
              background-color: white !important;
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              display: flex !important;
              visibility: visible !important;
              opacity: 1 !important;
              z-index: 1000 !important;
              
              // Garantir que os números da paginação sejam visíveis
              .ant-pagination-item,
              .ant-pagination-item-link {
                min-width: 32px;
                height: 32px;
                line-height: 30px;
                margin: 0 4px;
                display: inline-block !important;
                visibility: visible !important;
              }
              
              // Ajustar o espaçamento entre os elementos
              .ant-pagination-prev,
              .ant-pagination-next {
                margin: 0 8px;
                display: inline-block !important;
                visibility: visible !important;
              }
              
              // Garantir que o texto seja visível
              .ant-pagination-item a {
                font-size: 14px;
                font-weight: 500;
                display: block !important;
                visibility: visible !important;
              }
            }
          }
        }
      }
    }
  }
`;

export const ContainerProventos: any = styled.div`
  height: 400px;
  width: 100%;
  .empty-data {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    p {
      margin-top: 8px;
      font-weight: 500;
    }
  }
  .container-tooltip {
    display: flex;
    flex-direction: column;
    background-color: white;
    margin-top: 5px;
    padding: 5px;
    width: 100%;
  }
  .recharts-default-legend {
    display: inline !important;
    li {
      margin-right: 15px !important;
    }
  }
  .recharts-bar-rectangle {
    cursor: pointer;
  }
  .recharts-legend-wrapper {
    bottom: 0px !important;
  }
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
  }

  .recharts-legend-wrapper {
    left: 0px !important;
  }

  .recharts-layer > text {
    font-size: 12px;
    font-weight: 400;
    fill: black;
  }
  .ant-btn {
    border-radius: 10px;
  }
  .filter-proventos {
    width: 100%;
    display: flex;
    margin-bottom: 16px;
    button.ant-btn.ant-btn-default {
      height: 40px;
      svg.fill {
        fill: var(--ant-primary-color);
      }
    }
    .ant-select {
      margin-right: 8px;
    }
    .ant-select:not(:first-of-type) {
      margin-right: auto;
    }
  }
  @media only screen and (max-device-width: 812px) {
    margin-bottom: 64px;
    .filter-proventos {
      flex-wrap: wrap;
      .ant-select:first-of-type {
        width: 25%;
      }
      .ant-select:not(:first-of-type) {
        margin-right: 0;
        width: calc(75% - 8px);
      }
      button.ant-btn.ant-btn-default {
        width: 48.5%;
      }
    }
    .container-tooltip {
      width: auto;
    }
    .recharts-legend-wrapper {
      width: 100% !important;
      .recharts-default-legend {
        text-align: left !important;
        .recharts-legend-item {
          display: block !important;
        }
      }
    }
  }
`;

export const BlurContent = styled.div`
  width: 100%;
  margin: 10px;
  position: relative;
  user-select: none;
  border-radius: 4px;
  .blur-content {
    opacity: 0.5;
    filter: blur(4px);
  }
  .blur-content-title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 100px;
    font-weight: 500;
    font-size: 1.25rem;
    text-align: center;
    row-gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: var(--velotax-font-color-light);
  }

  @media only screen and (max-device-width: 812px) {
    .blur-content-title {
      padding: 0 16px;
      font-size: 1rem;
    }
  }
`;

export const BlurContentProventos = styled.div`
  width: 100%;
  margin: 10px;
  position: relative;
  user-select: none;
  border-radius: 4px;
  .blur-content {
    opacity: 0.5;
    filter: blur(4px);
  }
  .blur-content-title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 100px;
    font-weight: 500;
    font-size: 1.25rem;
    text-align: center;
    row-gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: var(--velotax-font-color-light);
  }

  @media only screen and (max-device-width: 812px) {
    .blur-content-title {
      padding: 0 16px;
      font-size: 1rem;
    }
  }
`;

export const SideContent = styled.div`
  z-index: 1;
  padding: 24px;
  min-width: 420px;
  max-width: 440px;
  max-height: 100%;
  overflow-y: hidden;
  box-shadow: 0px 0px 24px rgba(0, 0, 88, 0.08);

  h1 {
    margin: 6px 0;
  }

  & > .ant-row {
    height: 100%;
    align-items: start;
    .ant-col-clients-table {
      height: calc(100% - 100px);
      .ant-table-wrapper {
        height: 100%;
        .ant-spin-nested-loading {
          height: 100%;
          .ant-spin-container {
            height: calc(100% - 80px);
            .ant-table-pagination {
              width: 100%;
              // Estilos padrão para desktop
              position: relative;
              bottom: auto;
              margin: 16px 0 0 0;
              padding: 12px 16px;
              background-color: white;
              border-top: 1px solid var(--ghost);
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              display: flex;
              visibility: visible;
              opacity: 1;
              
              // Aplicar estilos específicos apenas em mobile
              @media only screen and (max-device-width: 812px) {
                z-index: 1000 !important;
              }
            }
            .ant-table {
              height: 100%;
              .ant-table-container {
                height: 100%;
                .ant-table-content {
                  height: 100%;
                  overflow-y: auto;
                  position: relative;
                  &::-webkit-scrollbar,
                  ::-webkit-scrollbar {
                    width: 0;
                  }
                  & > table {
                    .ant-table-thead {
                      top: 0;
                      z-index: 1;
                      position: sticky;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .client-notification {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 18px;
    height: 18px;
    display: flex;
    color: var(--white);
    border-radius: 9px;
    align-items: center;
    justify-content: center;
    background-color: var(--ant-error-color);
    &.large {
      width: 24px;
      span {
        font-size: 10px;
        line-height: 10px;
      }
    }
    span {
      font-weight: 500;
      font-size: 11px;
      line-height: 11px;
    }
  }

  // Estilos específicos para paginação em mobile apenas
  @media only screen and (max-device-width: 812px) {
    .ant-table-pagination {
      display: flex !important;
      align-items: center;
      visibility: visible !important;
      opacity: 1 !important;
      position: relative !important;
      bottom: auto !important;
      margin: 16px 0 0 0 !important;
      background-color: white !important;
      border-top: 1px solid var(--ghost);
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      z-index: 1000 !important;
      
      // Garantir que todos os elementos da paginação sejam visíveis
      .ant-pagination-item,
      .ant-pagination-item-link,
      .ant-pagination-prev,
      .ant-pagination-next {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
      
      .ant-pagination-item a {
        display: block !important;
        visibility: visible !important;
      }
    }
  }

  // Estilos específicos para paginação da tabela de clientes (desktop)
  .ant-row
    .ant-col-clients-table
    .ant-table-wrapper
    .ant-spin-nested-loading
    .ant-spin-container
    .ant-table-pagination {
    background-color: white;
    justify-content: center;
    display: flex;
    visibility: visible;
    opacity: 1;
    position: relative;
    bottom: 25px;
    margin: 16px 0 0 0;
    border-top: 1px solid var(--ghost);
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    
    
    // Garantir que todos os elementos da paginação sejam visíveis
    .ant-pagination-item,
    .ant-pagination-item-link,
    .ant-pagination-prev,
    .ant-pagination-next {
      display: inline-block;
      visibility: visible;
      opacity: 1;
    }
    
    .ant-pagination-item a {
      display: block;
      visibility: visible;
    }
    
    // Aplicar estilos específicos apenas em mobile
    @media only screen and (max-device-width: 812px) {
      bottom: 30px !important;
      z-index: 1000 !important;
    }
  }

  .ant-btn.ant-btn-primary.ant-btn-lg.ant-btn-block {
    height: 44px;
    font-size: 14px;
  }

  .ant-table-wrapper {
    max-width: unset;
    margin-left: -24px;
    width: calc(100% + 48px);

    .ant-table-row.selected-client {
      .ant-table-cell {
        background-color: #f8f8f8;
        &:not(.ant-table-selection-column) {
          border-right: 6px solid var(--ant-primary-color);
        }
      }
    }

    th.ant-table-cell.ant-table-selection-column {
      padding: 16px 0 16px 24px;
    }
    td.ant-table-cell.ant-table-selection-column {
      vertical-align: top;
      padding: 20px 0 16px 24px;
    }
  }
  .client-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.professionals {
      justify-content: end;
    }
    .client-table-header-btns {
      display: flex;
      column-gap: 8px;
      align-items: center;
      .ant-btn {
        height: 32px;
        min-width: 32px;
        font-weight: 500;
        border-radius: 24px;
        border: 1px solid var(--ghost);
        &.filtro-aplicado {
          color: var(--ant-primary-color);
          border: 1px solid var(--ant-primary-color);
          background-color: var(--ant-primary-1);
        }
        svg {
          fill: none;
          width: 18px;
          height: 18px;
          stroke: var(--ant-primary-color);
          &.fill {
            path {
              stroke: var(--ant-primary-color);
            }
          }
        }
      }
    }
  }
  .client-name {
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    svg {
      width: 16px;
      height: 16px;
      margin-left: 8px;
    }
  }
  .client-integration {
    margin-top: 10px;
    .ant-tag {
      font-size: 10px;
    }
  }
  .no-integration {
    color: var(--gray-1);
    border-color: var(--ghost);
    background-color: var(--ghost);
  }
  .has-integration {
    border-color: #e0f7ee;
    background-color: #e0f7ee;
    color: var(--ant-success-color);
  }

  .mobile-actions {
    display: none;
  }

  @media only screen and (max-device-width: 812px) {
    min-width: 100%;
    max-width: 100%;
    position: relative;
    & > .ant-row {
      .ant-col-clients-table {
        height: calc(100% - 124px + 32px);
      }
    }
    .mobile-actions {
      left: 0;
      bottom: 0;
      width: 100%;
      height: 56px;
      display: flex;
      padding: 8px 16px;
      position: absolute;
      background-color: var(--white);
      .ant-btn {
        height: 100%;
      }
    }
  }
`;

export const Content = styled.div`
  flex-grow: 1;
  height: 100%;
  padding: 32px 64px 96px;
  background-color: var(--ghost-white);
  overflow-x: hidden;
  overflow-y: auto;

  .calc-status {
    /* width: fit-content; */
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 6px;
    span:first-of-type {
      width: 8px;
      height: 8px;
      min-width: 8px;
      min-height: 8px;
      border-radius: 4px;
      display: inline-block;
      background-color: var(--red);
      &.Regular {
        background-color: var(--green);
      }
      &.NOT_PAYED {
        background-color: var(--ant-primary-color);
      }
    }
  }

  .ant-btn-group.ant-dropdown-button {
    .ant-btn {
      text-transform: none;
      border-color: var(--dark-1);
      :first-of-type {
        border-radius: 24px;
        margin-right: 8px;
      }
      :last-of-type {
        border-radius: 24px;
      }
      :disabled,
      :hover {
        color: var(--gray-1);
        border-color: var(--gray-1);
      }
      &.ant-dropdown-trigger {
        svg {
          fill: var(--dark-1);
        }
        :disabled,
        :hover {
          svg {
            fill: var(--gray-1);
          }
        }
      }
    }
  }

  .ant-list.ant-list-split {
    padding: 0 32px;
    border: 2px solid var(--dark-1);
    border-radius: 8px;
    .ant-list-item-action > li {
      padding: 0;
    }
  }
  .ant-list-item {
    padding: 20px 0;
  }
  .ant-list-item-meta-title {
    font-size: 1rem;
    font-weight: 700;
  }
  .ant-list-item-action > li,
  .ant-list-item-meta-title,
  .ant-list-item-meta-description {
    color: var(--white);
  }
  .ant-list-item-action {
    display: flex;
    row-gap: 4px;
    column-gap: 8px;

    .ant-btn.hire-btn {
      color: var(--ant-primary-color) !important;
      border-color: var(--dark-1);
      background-color: var(--dark-1);
    }

    .ant-btn.action-btn {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      row-gap: 0;
      height: 48px;
      padding: 0 4px;
      font-size: 14px;
      color: var(--white);

      svg,
      svg * {
        stroke: var(--ant-primary-color);
      }
    }
  }
  .ant-list-item-action-split {
    display: none;
  }
  .ant-list-item-meta-description {
    opacity: 0.75;
  }

  .ant-btn {
    span {
      line-height: 18px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
    svg {
      min-width: 20px;
      min-height: 20px;
    }
  }

  .resp {
    p {
      margin: 0;
      text-align: left;
      max-width: 128px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  @media only screen and (max-device-width: 812px) {
    left: 0;
    top: 100%;
    z-index: 2;
    padding: 0;
    position: fixed;
    border-radius: 0;
    transition: top 0.2s;
    background-color: var(--white);

    &.mobile-show {
      top: 0;
      width: 100%;
      z-index: 5;
    }

    .ant-list.ant-list-split {
      padding: 0 16px;
      font-size: 12px;

      .ant-list-item {
        padding: 16px 0;
      }

      .ant-list-item-action {
        flex-direction: column;
      }
    }

    .ant-table-content {
      overflow-y: auto;
    }
  }
`;

export const ClientPlanContent = styled.div`
  .client-plan {
    height: 20px;
    display: flex;
    font-size: 10px;
    color: #0f1a2ae6;
    font-weight: 400;
    &.professional {
      display: flex;
      font-size: 12px;
      column-gap: 4px;
      align-items: center;
    }
  }
  .client-no-plan {
    height: 24px;
    display: flex;
    font-size: 10px;
    font-weight: 500;
    align-items: center;
    color: var(--ant-error-color);
    svg {
      margin-top: -1px;
    }
  }
`;

export const EmptyContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-size: 32px;
    font-weight: 600;
    line-height: 40px;
    text-align: center;
    color: var(--velotax-font-color);
    letter-spacing: -0.32px;
    margin-top: 32px;
  }
  div.ant-typography {
    max-width: 400px;
    color: var(--velotax-font-color-ghost);
    text-align: center;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  }

  .action-buttons {
    min-width: 540px;
    justify-content: center;
    .btn-underlined {
      span {
        font-weight: 500;
        padding-bottom: 4px;
        border-bottom: 2px solid var(--ant-primary-color);
      }
    }
    .button-disabled-plan {
      position: relative;

      .over-button-disabled {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 999;
      }
    }
  }

  .close-selection {
    display: none;
  }

  @media only screen and (max-device-width: 812px) {
    width: 100%;
    height: auto;
    padding: 24px;
    min-height: 100%;
    position: relative;
    svg {
      width: 100%;
      height: auto;
    }
    div.ant-typography {
      max-width: 100%;
    }
    .action-buttons {
      min-width: unset;
      max-width: 100%;
    }
    .close-selection {
      display: flex;
      position: absolute;
      top: 24px;
      right: 24px;
    }
  }
`;

export const ClientContainer = styled.div`
  min-width: 640px;
  max-width: 895px;
  margin: 0 auto;
  .ant-badge-count.ant-badge-multiple-words {
    padding: 0 4px;
  }
  .client-actions {
    display: flex;
    align-items: center;
    justify-content: end;
    column-gap: 8px;
    margin-bottom: 24px;

    .close-client {
      display: none;
    }

    .ant-btn {
      border: none;
      height: 40px;
      color: var(--ant-primary-color);
      font-size: 14px;
      min-width: 40px;
      font-weight: 500;
      border-radius: 24px;
      background: #1634ff14;
    }
  }
  .client-content {
    padding: 48px;
    border-radius: 8px;
    background-color: var(--white);
    box-shadow: 0px 4px 8px 0px #e0e0e0;
    position: relative;

    .client-header {
      min-height: 40px;
    }

    h1 {
      display: flex;
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      color: var(--black);
      align-items: center;
      margin-bottom: 4px;
      svg {
        margin-left: 12px;
      }
      span {
        display: flex;
        align-items: center;
      }

      .contratar-plano {
        margin-left: auto;
        .ant-btn {
          height: 40px;
        }
      }
    }

    .notification-button {
      position: absolute;
      right: 48px;
      top: 48px;

      button {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background: #1634ff14;
        border-color: transparent;
        transition: 0.3s;
      }

      svg {
        font-size: 28px;
      }

      @media only screen and (max-device-width: 812px) {
        right: 8px;
        top: 16px;
      }
    }
  }

  .client-info {
    padding-top: 12px;
    margin: 24px 0 32px;
    border-top: 1px solid var(--ghost);
    &.professional {
      margin: 24px 0 8px;
    }
    .client-info-title {
      color: var(--dark-2);
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }
    .client-info-data {
      color: var(--gray-2);
      font-size: 14px;
      font-weight: 300;
      line-height: 20px;
      .dashed {
        border-bottom: 1px dashed var(--gray-2);
      }
      .concierge {
        color: var(--gray-2);
        cursor: pointer;
      }
      .ativar-concierge {
        color: blue;
        opacity: 0.8;
        cursor: pointer;
        align-items: center;
        display: flex;
        justify-content: space-around;
      }
    }
  }

  .client-details {
    padding: 32px 48px 0;
    margin-left: -48px;
    margin-bottom: -48px;
    width: calc(100% + 96px);
    background-color: #f8fbfd;
    border-radius: 0 0 8px 8px;

    .tab-title {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        transform: translateY(-1px);
        margin-left: 4px;
      }
    }

    .spinTabs {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .client-details-loading {
      height: 128px;
      display: flex;
      align-items: center;
      padding-bottom: 32px;
      justify-content: center;
      .anticon-loading {
        width: 32px;
        height: 32px;
        svg {
          width: 32px;
          height: 32px;
          fill: var(--ant-primary-color);
        }
      }
    }
  }

  .ant-tabs {
    &.gambiarra-uma-tab {
      .ant-tabs-nav {
        .ant-tabs-nav-wrap {
          .ant-tabs-nav-list {
            .ant-tabs-ink-bar {
              left: 0 !important;
              width: 100% !important;
            }
            .ant-tabs-tab {
              width: 100%;
            }
          }
        }
      }
    }
    .ant-tabs-tab + .ant-tabs-tab {
      margin: 0;
    }
    .ant-tabs-nav {
      margin: 0 0 32px;
      .ant-tabs-nav-operations {
        display: none;
      }
      .ant-tabs-nav-wrap {
        .ant-tabs-nav-list {
          width: 100%;
          .ant-tabs-ink-bar {
            background-color: var(--ant-primary-color);
          }
          .ant-tabs-tab {
            width: 50%;
            justify-content: center;
            .ant-tabs-tab-btn {
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
              color: var(--gray-1);
              text-transform: uppercase;
            }
            &.ant-tabs-tab-active {
              .ant-tabs-tab-btn {
                color: var(--ant-primary-color);
              }
            }
          }
        }
      }
    }
  }

  .aviso-list-empty {
    padding: 16px;
    margin-top: 0;
    border-radius: 8px;
    text-align: center;
    margin-bottom: 48px;
    color: var(--velotax-font-color);
    background-color: var(--ghost);
  }

  .client-integration-card {
    padding: 24px;
    border-radius: 8px;
    background-color: #e6edff;
    display: flex;
    align-items: start;
    margin-bottom: 1rem;
    &:last-of-type {
      /* margin-bottom: 48px; */
    }
    & > svg {
      min-width: 32px;
      min-height: 32px;
      color: var(--ant-primary-color);
      stroke: var(--ant-primary-color);
      &.fill {
        fill: var(--ant-primary-color);
      }
    }

    .client-integration-card-content {
      width: 100%;
      margin-left: 16px;
      h3 {
        color: var(--ant-primary-color);
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 8px;
      }
      div.ant-typography {
        color: var(--velotax-font-color-ghost);
        font-size: 14px;
        font-weight: 300;
        line-height: 20px;
        width: calc(100% - 32px);
      }
      .ant-btn {
        padding: 0;
        border: none;
        font-size: 14px;
        font-weight: 600;
      }
      button {
        display: flex;
        align-items: center;
        height: 22px;
        svg {
          margin-left: 4px;
        }
      }
    }
  }

  .aviso-rendimentos-card {
    margin-bottom: 1rem !important;
  }

  .client-wallet-header-btns {
    display: flex;
    column-gap: 8px;
    align-items: center;
    .ant-btn {
      height: 32px;
      min-width: 32px;
      font-weight: 500;
      border-radius: 24px;
      border: 1px solid var(--ghost);
      &.filtro-aplicado {
        color: var(--ant-primary-color);
        border: 1px solid var(--ant-primary-color);
        background-color: var(--ant-primary-1);
      }
      svg {
        fill: none;
        width: 18px;
        height: 18px;
        stroke: var(--ant-primary-color);
        &.fill {
          path {
            stroke: var(--ant-primary-color);
          }
        }
      }
    }
  }

  .investimentos-container {
    .list-empty {
      padding: 16px;
      margin: 48px 0;
      border-radius: 8px;
      text-align: center;
      color: var(--velotax-font-color);
      background-color: var(--ghost);
    }
    .patrimonio-atual {
      /* padding: 0 32px 0 48px; */
      color: var(--dark-2);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      h2 {
        font-size: 38px;
        font-weight: 700;
        line-height: 48px;
        margin-bottom: 8px;
        letter-spacing: -0.4px;
        
        @media (max-width: 1600px) {
          font-size: 30px;
        }
      }
    }
    .lucro-prejuizo-diario-total {
      padding: 0 16px;
      color: var(--dark-2);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
    .grafico-container {
      position: relative;
      margin: 48px 0 16px;
  

      .recharts-legend-wrapper {
        top: 32px !important;
        left: 400px !important;
        right: unset !important;
        width: 100% !important;
        max-width: 200px !important;
      }

   /* Adiciona profundidade ao gráfico */
   .recharts-wrapper {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1)) !important;
    margin: 10px !important;
    padding: 10px !important;
  }
  
  /* Efeito de elevação para os setores */
  .recharts-pie-sector path {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2)) !important;
  }
  
  /* Efeito de profundidade adicional */
  .recharts-pie-sector {
    position: relative;
  }
  
  .recharts-pie-sector::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
  }

      // Remove bordas brancas do gráfico
      .recharts-pie-sector {
        stroke: none !important; // Remove as bordas brancas entre as fatias
      }
      
      // Remove bordas do gráfico de pizza
      .recharts-pie {
        stroke: none !important;
      }
      
      // Remove bordas das células individuais
      .recharts-pie-sector path {
        stroke: none !important;
      }
      
      // Remove bordas do container do gráfico
      .recharts-wrapper {
        stroke: none !important;
      }

     

    
    }

    .select-container-corretora {
      display: flex;
      max-width: 50%;
      margin-top: 82px;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      .ant-select-selection-item {
        height: 32px;
        padding: 0 0 4px 28px;
      }
      .ant-select-arrow {
        left: 0;
        right: unset;
        svg {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

      }
      .update-patrimonio {
        margin-top: 4px;
        font-size: 12px;
        font-weight: 500;
        max-width: 240px;
        text-align: center;
        color: var(--gray-1);
      }
    }

    .select-container {
      top: 0;
      right: 0;
      width: 50%; // para alinhar com o prejuizo
      position: absolute;
      display: flex;
      align-items: center;
    }

    .select-container,
    .select-container-corretora {
      .ant-select {
        min-width: 240px;
        border-radius: 0px !important;
        .ant-select-selector {
          height: 32px;
          border: none !important;
          padding: 0 0 0px !important;
          border-radius: 0px !important;
          background-color: transparent !important;
          border-bottom: 1px solid var(--dark-2) !important;
          .ant-select-selection-search,
          .ant-select-selection-item {
            display: flex;
            font-size: 14px;
            align-items: center;
            font-weight: 400 !important;
          }
        }
        .ant-select-arrow {
          top: calc(50% - 2px);
        }
      }

      .ant-select-focused.ant-select-open {
        box-shadow: none !important;

        .ant-select-selector {
          border-color: var(--ant-primary-color) !important;
        }
      }

      .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
      .ant-select-focused:not(.ant-select-disabled).ant-select:not(
          .ant-select-customize-input
        )
        .ant-select-selector {
        box-shadow: none !important;
      }

      .ant-dropdown,
      .ant-select-dropdown {
        box-shadow: none;
      }

      .ant-select-item-option-content {
        font-size: 14px;
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    margin: 0;
    min-width: 100%;
    max-width: 100%;
    background-color: var(--white);

    .client-wallet-header-btns {
      width: 100%;
      margin-top: 8px;
    }

    .client-actions {
      margin: 0;
      padding: 12px;
      border-bottom: 1px solid var(--ghost);
      .close-client {
        display: flex;
      }
    }
    .client-content {
      padding: 24px;
      border-radius: 0;
      box-shadow: none;
      h1 {
        align-items: flex-start;
        flex-direction: column;
        width: calc(100% - 42px);

        span {
          display: block;
          svg {
            margin-left: 8px;
            margin-bottom: -5px;
          }
        }
        .contratar-plano {
          margin: 0;
          width: 100%;
          .ant-btn {
            width: 100%;
            margin: 8px 0 0;
          }
        }
      }
      .notification-button {
        top: 12px;
        right: 12px;
      }
    }
    .client-details {
      padding: 32px 24px !important;
      margin-left: -24px;
      width: calc(100% + 48px);
      .ant-tabs {
        .ant-tabs-nav {
          margin-left: -24px;
          width: calc(100% + 48px);
        }
      }
    }
    .client-integration-card {
      .client-integration-card-content {
        div.ant-typography {
          width: 100%;
        }
      }
    }
    .ant-tabs {
      .ant-tabs-nav {
        margin: 0 0 24px;
        .ant-tabs-nav-wrap {
          .ant-tabs-nav-list {
            .ant-tabs-tab {
              padding: 8px 4px;
              .ant-tabs-tab-btn {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
         .investimentos-container {
       width: 100%;
             
        .cards-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 16px;
        width: 100%;
      }

      .card {
        border: 1px solid #d4af37; /* borda dourada */
        border-radius: 8px;
        padding: 16px;
        text-align: center;
      }

       
       .patrimonio-atual {
         padding: 0;
         h2 {
           font-size: 30px;
         }
       }
      .lucro-prejuizo-diario-total {
        display: flex;
        font-size: 12px;
        column-gap: 16px;
        margin-top: 16px;
        padding: 16px 0 0;
        border-top: 1px solid var(--ghost);
      }
        .grafico-container {
         margin: 64px 0 16px;

         .recharts-legend-wrapper {
           top: -8px !important;
           left: 200px !important;
           right: unset !important;
           font-size: 12px;
         }
         .select-container {
           top: -48px;
           left: 0;
           width: 100%;
           display: flex;
           position: absolute;
           align-items: center;
         }

        /* Remove bordas brancas do gráfico de pizza */
  .recharts-pie-sector {
    stroke: none !important;
  }
  
  .recharts-pie-sector path {
    stroke: none !important;
  }
  
  /* Remove bordas de todos os elementos do gráfico */
  .recharts-wrapper svg {
    stroke: none !important;
  }
  
  .recharts-pie {
    stroke: none !important;
  }
  
  /* Efeito 3D para o gráfico de pizza */
  .recharts-pie-sector {
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15)) !important;
    transition: all 0.3s ease !important;
  }
  
  .recharts-pie-sector:hover {
    filter: drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.25)) !important;
    transform: translateY(-2px) scale(1.02) !important;
  }
  
  /* Animação sutil de entrada */
  .recharts-pie-sector {
    animation: fadeInUp 0.6s ease-out;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Adiciona profundidade ao gráfico */
  .recharts-wrapper {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1)) !important;
    margin: 10px !important;
    padding: 10px !important;
  }
  
  /* Efeito de elevação para os setores */
  .recharts-pie-sector path {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1)) !important;
  }
  
  /* Efeito de profundidade adicional */
  .recharts-pie-sector {
    position: relative;
  }
  
  .recharts-pie-sector::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
  }
         
         }
        
    }
  }
`;

export const HiredTag = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  padding: 4px 16px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: var(--white);
  background-color: var(--dark-1);
`;

export const SelectedContainer = styled.div`
  display: flex;
`;

export const PatrimonioContainer = styled.div``;

export const Patrimonio = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoLabel = styled.p`
  margin: 0;
  white-space: nowrap;
  font-size: 12px;
  color: #1890ff;
  font-weight: 500;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(12px);

  &:hover {
    color: #0071d9;
    text-decoration: underline;
    transition: 0.3s;
  }
`;

export const B3Link = styled.a`
  display: block;
  font-size: 10px;
  color: rgb(1, 103, 153);
  text-align: center;
  margin: auto;
  width: 450px;

  &:hover {
    text-decoration: underline;
    color: rgb(1, 103, 153);
  }
`;

export const CopyLink = styled.button`
  color: #0566cd;
  font-weight: 500;
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
    color: #06417f;
  }
`;

export const ShareItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #06417f;
  }

  img {
    width: 40px;
    height: 40px;
  }

  p {
    font-size: 11px;
    margin: 0.5rem 0;
  }
`;

export const Instructions = styled.p`
  font-size: 13px;
  margin-bottom: 4px;
`;

export const Paragraph = styled.p<{ color?: string }>`
  margin: 0;
  color: ${({ color }) => color ?? ""};
`;

export const PatrimonioHeader = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const PatrimonioValue = styled.p`
  font-size: 36px;
  font-weight: 700;
`;

export const RetornoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  border-left: 1px solid var(--ghost);
  padding-left: 0.5rem;
  justify-content: space-around;
`;

export const RetornoLabel = styled.p<{ retorno: number }>`
  margin: 0 0 8px;
  color: ${({ retorno }) =>
    retorno > 0
      ? "#4DCD66"
      : retorno < 0
        ? "var(--ant-error-color)"
        : "var(--gray-2)"};
`;

export const RelatorioButton = styled.button`
  display: flex;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  fill: var(--ant-primary-color);
  color: var(--ant-primary-color);

  svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  &:hover {
    color: var(--ant-primary-color-active);
    fill: var(--ant-primary-color-active);
    transition: 0.3s;
  }
`;

export const IsentCardStyled = styled.div`
  gap: 12px;
  border: none;
  display: flex;
  height: 110px;
  padding: 23px;
  margin-bottom: 4px;
  border-radius: 8px;
  text-align: center;
  flex-direction: column;
  background-color: var(--light-gray);

  .overviewTitleIsent {
    color: var(--black);
    font-size: 13px;
  }
`;

export const ConatinerDarfs = styled.div`
  min-height: 400px;
  width: 100%;
  padding-bottom: 2rem;
  position: relative;
  overflow: visible;
`;

export const BlurBox = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 6rem;
  position: absolute;
  top: -20px;
  left: -20px;
  width: calc(100% + 40px);
  height: 100%;
  background-color: #f8f8f88f;
  backdrop-filter: blur(10px);
  z-index: 10;

  .blur-content-title {
    font-weight: 500;
    font-size: 1.25rem;
    text-align: center;
    row-gap: 16px;
    color: var(--velotax-font-color-light);
    max-width: 500px;
  }
`;

export const FilterDarfs = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  justify-content: space-between;

  .filterYear {
    min-width: 120px;
  }

  .buttonFilter {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
  }

  @media only screen and (max-device-width: 450px) {
    .filterYear {
      flex-grow: 1;
      width: 100%;
      margin-bottom: 1rem;
    }
    .buttonFilter {
      button {
        width: calc(50% - 4px);
      }
    }
  }
`;

export const DarfFilterButton = styled.button<{ selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 1rem;
  border-radius: 2rem;
  background-color: ${({ selected }) => (selected ? "black" : "white")};
  color: ${({ selected }) => (selected ? "white" : "black")};
  border: 1px solid black;
  transition: 0.3s;

  &:hover {
    background-color: ${({ selected }) =>
    selected ? "black" : "var(--ghost)"};
    transition: 0.3s;
  }
`;

export const DarfCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 1rem;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      font-size: 18px;
      font-weight: 600;
      margin: 0;
    }

    button {
      height: 20px;
      font-size: 11px;
      font-weight: 500;
      text-transform: uppercase;
      background-color: var(--gray-1);
      border-radius: 1rem;
      padding: 0 0.5rem;
    }

    .payed {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--ant-success-color);
      color: white;

      svg {
        font-size: 16px;
        margin-left: 2px;
        transform: translateY(-1px);
      }
    }
  }

  .body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .resumo {
    flex-grow: 1;
    p {
      margin: 0;
      max-width: 240px;
      display: flex;
      justify-content: space-between;

      strong {
        min-width: 100px;
        font-weight: 600;
      }
    }

    .empty {
      max-width: 100%;
      color: var(--gray-2);
      font-weight: 300;
    }
  }

  .actions {
    display: flex;
    align-items: center;

    button {
      height: 40px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 4px;
      text-transform: uppercase;

      svg {
        color: var(--ant-primary-color);
      }

      &:first-of-type {
        margin-right: 4px;
      }

      &:last-of-type {
        text-transform: none;
      }
    }
  }

  @media only screen and (max-device-width: 550px) {
    .actions {
      width: 100%;
      margin-top: 1rem;

      button {
        flex-grow: 1;
      }
    }
    
    // Ajustes adicionais para paginação em telas muito pequenas
    .ant-col-clients-table {
      .ant-table-wrapper {
        .ant-spin-nested-loading {
          .ant-spin-container {
            .ant-table-pagination {
              padding: 12px !important;
              display: flex !important;
              visibility: visible !important;
              opacity: 1 !important;
              position: relative !important;
              bottom: auto !important;
              
              // Reduzir o tamanho dos itens da paginação em telas muito pequenas
              .ant-pagination-item,
              .ant-pagination-item-link {
                min-width: 28px;
                height: 28px;
                line-height: 26px;
                margin: 0 2px;
                display: inline-block !important;
                visibility: visible !important;
              }
              
              // Ajustar o espaçamento dos botões de navegação
              .ant-pagination-prev,
              .ant-pagination-next {
                margin: 0 4px;
                display: inline-block !important;
                visibility: visible !important;
              }
              
              // Garantir que o texto seja legível
              .ant-pagination-item a {
                font-size: 12px;
                display: block !important;
                visibility: visible !important;
              }
              
              // Ajustar o layout para telas muito pequenas
              .ant-pagination-options {
                display: none; // Ocultar opções de tamanho de página em mobile
              }
            }
          }
        }
      }
    }
  }
`;

export const PlanContainer = styled.div`
  width: fit-content;
  background-color: var(--velotax-background-color);
  padding: 2rem 2rem;
  margin: auto;
`

export const SearchInput = styled.div`
  .clients-search-input {
    .ant-input-affix-wrapper {
      border-radius: 12px;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    }
  }
`;

// Estilo personalizado para o input de busca
export const SearchInputClients = styled.div`
  .clients-search-input {
    .ant-input-affix-wrapper {
      // Remove a borda externa
      border: none !important;
    }
    
    .ant-input {
      // Remove a borda interna
      border: none !important;
      outline: none !important;
      
      &:focus {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
      }
    }
    
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); 
  }
`;





export const CardCorretora= styled.div`
  border: 1px solid #B8860B;
  border-radius: 8px;
  padding: 10px;
  background-color: '#fafafa';      
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); 
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TitleCorretora = styled.span`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const ValueCorretora = styled.span`
  font-size: 10px;
  color: #222;
  font-weight: 600;
  line-height: 1.4; 
`;

export const PercentageCorretora = styled.span`
  font-size: 10px;
  color: #555;
  font-weight: 600;
  line-height: 1.4; 
`;